module.exports = __webpack_public_path__ + "img/liangxin-hualu-top.ab25ea39.png";